import {memo, RefObject} from 'react';

import styled from 'styled-components';

import useLineStyles from '~/shared/components/TabOrangeLine/useLineStyles';

const OrangeLine = styled.div<{left: number; width: number}>`
  position: absolute;
  bottom: 0;
  left: ${({left}) => left}px;
  width: ${({width}) => width}px;
  height: 4px;
  background: ${({theme}) => theme.colors.contentBrand};
  border-radius: 2px 2px 0 0;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
`;

type TabOrangeLineProps = {
  elsRefs: RefObject<(HTMLElement | null)[]>;
  currentIndex: number;
};

const TabOrangeLine = ({elsRefs, currentIndex}: TabOrangeLineProps) => {
  const lineStyles = useLineStyles(elsRefs, currentIndex);

  if (!lineStyles.isReady) {
    return null;
  }

  return (
    <OrangeLine
      left={lineStyles.left}
      width={lineStyles.width}
    />
  );
};

export default memo(TabOrangeLine);
